import { Cms } from '@typings';
import { createAction } from 'typesafe-actions';

export const resetCms = createAction('cms/RESET')();

export const setPreviewData = createAction('cms/SET_PREVIEW_DATA')<{
  data: Cms.FullPageData;
}>();
